module.exports = __webpack_public_path__ + "img/icon-instagram.32318040.svg";